// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../types';

import gql from 'graphql-tag';
export type OptionalExtrasProposalFragment = { __typename?: 'Proposal', ID: number, currency: string, extraCostItems?: Array<{ __typename?: 'ExtraCostItem', ID: number, description: string, costPerUnit: number }> | null };

export const OptionalExtrasProposalFragmentDoc = gql`
    fragment OptionalExtrasProposal on Proposal {
  ID
  currency
  extraCostItems {
    ID
    description
    costPerUnit
  }
}
    `;